export default __webpack_public_path__ + "static/media/specialseat.33501e7a.mp3";